<template>
  <div>
    <order  :caozuo_flag_props="3" > </order> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import order from '../../tongyong/order.vue';
 
export default {

  components: {
    order: order 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
